(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfValidateDependingOn', [
    '$parse', function($parse) {
      return {
        require: 'ngModel',
        scope: {
          mfValidateDependingOn: '='
        },
        link: (function(_this) {
          return function(scope, element, attrs, ngModel) {
            return scope.$watch('mfValidateDependingOn.$modelValue', function(value) {
              ngModel.$setDirty(true);
              return ngModel.$validate();
            });
          };
        })(this)
      };
    }
  ]);

}).call(this);
